import { createContext, useContext, type ReactNode, type ReactElement } from 'react';
import { useStore } from './store.js';
import type { MailController, MailState } from './mail-store.js';

const ControllerContext = createContext<MailController | undefined>(undefined);

export function ControllerProvider(props: {
  controller: MailController;
  children: ReactNode;
}): ReactElement {
  return (
    <ControllerContext.Provider value={props.controller}>
      {props.children}
    </ControllerContext.Provider>
  );
}

export function useController(): MailController {
  const controller = useContext(ControllerContext);
  if (controller === undefined) {
    throw new Error('useController must be used inside a ControllerProvider.');
  }
  return controller;
}

export function useMail<S>(select: (state: MailState) => S): S {
  return useStore(useController().store, select);
}
